import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private _userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  isMobile(): boolean {
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(this._userAgent);
  }

  isTablet(): boolean {
    return /iPad|Tablet|PlayBook|Silk/i.test(this._userAgent) || (this.isIOS() && this.isMacLike() && this.hasTouchSupport());
  }

  isIpad(): boolean {
    return /iPad/.test(this._userAgent) || (this._userAgent.includes('Macintosh') && 'ontouchend' in document);
  }

  isIphone(): boolean {
    return /iPhone/i.test(this._userAgent);
  }

  isIOS(): boolean {
    return /iPhone|iPad|iPod/i.test(this._userAgent);
  }

  isAndroid(): boolean {
    return /Android/i.test(this._userAgent);
  }

  isDesktop(): boolean {
    return !this.isMobile() && !this.isTablet();
  }

  isEdge(): boolean {
    return /Edg|Edge|EdgiOS|EdgA/i.test(this._userAgent);
  }

  isChrome(): boolean {
    return /Chrome|CriOS/i.test(this._userAgent) && !this.isEdge();
  }

  isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(this._userAgent);
  }

  isFirefox(): boolean {
    return /Firefox|FxiOS/i.test(this._userAgent);
  }

  private hasTouchSupport(): boolean {
    return 'ontouchend' in document;
  }

  // INFO: Zusatzfunktionen für iPadOS > 13
  private isMacLike(): boolean {
    return /Macintosh/i.test(this._userAgent);
  }
}
